import { CSS } from '../../../../theme/stitches.config';
import { SMPIcon, StyledIconVariants } from '../SMPIcon';

type SMPCleansheetsIconProps = StyledIconVariants & {
  css?: CSS;
};

export const SMPCleansheetsIcon = (props: SMPCleansheetsIconProps): JSX.Element => {
  return (
    <SMPIcon {...props}>
      <svg fill='currentColor'>
        <path d='M16.9889 14V13.9H16.8889H16H15.9V14V16.9999V17.0999H16H16.8889H16.9889V16.9999V14Z' fill='black' strokeWidth='0.1' />
        <path
          d='M0.888916 0.95H0.838916V1V17V17.05H0.888916H3.55558H3.60558V17V14.3833H7.06114V17V17.05H7.11114H8.00003H8.05003V17V14.3833H11.5056V17V17.05H11.5556H12.4445H12.4945V17V14.3833H20.3945V17V17.05H20.4445H23.1111H23.1611V17V1V0.95H23.1111H0.888916ZM11.5056 10.8278V13.3944H8.05003V10.8278H11.5056ZM12.4945 13.3944V10.8278H15.95V13.3944H12.4945ZM8.05003 9.83889V7.27222H11.5056V9.83889H8.05003ZM3.60558 7.27222H7.06114V9.83889H3.60558V7.27222ZM16.9389 6.28333V3.71667H20.3945V6.28333H16.9389ZM2.61669 2.77778V16.0611H1.8278V1.93889H22.1722V16.0611H21.3834V2.77778V2.72778H21.3334H2.66669H2.61669V2.77778ZM7.06114 13.3944H3.60558V10.8278H7.06114V13.3944ZM3.60558 6.28333V3.71667H7.06114V6.28333H3.60558ZM11.5056 6.28333H8.05003V3.71667H11.5056V6.28333ZM15.95 9.83889H12.4945V7.27222H15.95V9.83889ZM15.95 6.28333H12.4945V3.71667H15.95V6.28333ZM20.3945 13.3944H16.9389V10.8278H20.3945V13.3944ZM16.9389 7.27222H20.3945V9.83889H16.9389V7.27222Z'
          fill='currentColor'
          strokeWidth='0.1'
        />
      </svg>
    </SMPIcon>
  );
};
